import React, { Component } from 'react';
import { TextField, Button, Stack, Paper, Divider } from '@mui/material';

import { styled } from '@mui/material/styles';
import { connect } from 'react-redux';
import Page from '../../components/Page';
import CodeIcon from '@mui/icons-material/Code';
import KeyIcon from '@mui/icons-material/Key';
import { post } from '../../util/api';
// eslint-disable-next-line
// import styled from 'styled-components/macro';

const Item = styled(Paper)(({ theme }) => ({
	backgroundColor: '#ffff',
	...theme.typography.body2,
	padding: theme.spacing(1),
	textAlign: 'center',
	color: theme.palette.text.secondary,
}));

class ScriptPage extends Component {
	state = {
		copiedPid: false,
		copiedToken: false,
		loading: true,
	};
	componentDidMount() {
		this.getIntegration();
	}
	async getIntegration() {
		let { product } = this.props;
		let pid = product.id;
		await post('/dialogflow/getIntegration', { pid }).then((data) => {
			let result = data.data;
			let integrations = result.integrations;

			if (integrations && integrations.id) {
				this.setState({ project_id: integrations.shop, selectedFile: integrations.data.file_name, languageCode: integrations.data.languageCode });
			}
			this.setState({ integrations, loading: false });
		});
	}
	async insertIntegration() {
		let { fileContent, languageCode, project_id, selectedFile, integrations } = this.state;
		await post('/dialogflow/upsertIntegration', {
			project_id,
			languageCode,
			credentials: fileContent,
			file_name: selectedFile,
			id: integrations && integrations.id,
		});
		this.getIntegration();
	}
	handleFileChange = (event) => {
		const file = event.target.files[0];
		console.log('file', file);
		const reader = new FileReader();

		reader.onload = (e) => {
			const content = e.target.result;
			console.log('content', content);
			this.setState({ fileContent: content, selectedFile: file.name });
		};

		reader.readAsText(file);
	};
	render() {
		let { loading, project_id, selectedFile, languageCode } = this.state;
		if (loading)
			return (
				<Page title="Developers" subtitle="DialogFlow" icon={<CodeIcon />}>
					<Page.Loader></Page.Loader>
				</Page>
			);
		return (
			<Page title="Developers" subtitle="DialogFlow" icon={<CodeIcon />}>
				<Stack spacing={2}>
					<Item>
						<Divider sx={{ fontSize: '17px' }} textAlign="left">
							<KeyIcon /> Dialogflow
						</Divider>
						<form style={{ textAlign: 'left' }}>
							<TextField
								fullWidth
								margin="normal"
								label="Project Id"
								value={project_id ? project_id : ''}
								type="text"
								defaultValue={project_id}
								onChange={({ target: { value } }) => this.setState({ project_id: value })}
							></TextField>
							<TextField
								fullWidth
								margin="normal"
								label="Language Code"
								value={languageCode ? languageCode : ''}
								type="text"
								defaultValue={languageCode}
								onChange={({ target: { value } }) => this.setState({ languageCode: value })}
							></TextField>
							<div style={{ display: 'flex', alignItems: 'center' }}>
								<TextField
									fullWidth
									label="JSON File"
									margin="normal"
									value={selectedFile ? selectedFile : ''}
									InputProps={{
										readOnly: true,
										endAdornment: (
											<label htmlFor="contained-button-file">
												<Button variant="contained" component="span">
													Import
												</Button>
											</label>
										),
									}}
								/>
								<input accept=".json" id="contained-button-file" type="file" style={{ display: 'none' }} onChange={this.handleFileChange} />
							</div>
							<Button variant="contained" component="span" onClick={() => this.insertIntegration()}>
								Save
							</Button>
						</form>
					</Item>
				</Stack>
			</Page>
		);
	}
}

export default connect((state) => ({ user: state.access.user.loggedUserObj, product: state.product.maytapi }))(ScriptPage);
